import { render, staticRenderFns } from "./fragment-gfx-submit.vue?vue&type=template&id=96be83f8&scoped=true&"
import script from "./fragment-gfx-submit.vue?vue&type=script&lang=js&"
export * from "./fragment-gfx-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96be83f8",
  null
  
)

export default component.exports